const LoadingScreen = () => (
  <div className="min-h-screen flex bg-gray-50 flex-col items-center justify-center fixed inset-0 z-50">
    <div className="flex flex-col items-center justify-center gap-4">
      {/* Favicon con animación de escala sutil */}
      <img src="/favicon.ico" alt="Cargando..." className="relative w-12 h-12 animate-scale-pulse" />
      <p className="text-gray-600">Cargando...</p>
    </div>
  </div>
);

export default LoadingScreen;